import React from 'react';
import DashboardHeader from '../components/Header/HeaderMetrics';
import ClosedList from '../components/CaseList/ClosedList';

const ArchiveSummary = () => {
  return (
    <div className="flex flex-col gap-4 h-screen">
        <div><ClosedList /></div>
    </div>
  );
};

export default ArchiveSummary;
